import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'

const desmosValidationSelector = createSelector(
	[ state => state.desmos ],
	() => {

		// Work in progress: Validation will be implemented in a future
		const valid = true

		return {
			valid,
			message: valid?'':localize('global_generic_error'),
		}
	}
)

export default desmosValidationSelector
